import ls from 'local-storage';

const KEY = 'ACTIVE_ORGANIZATION_ID';

// sessionStorage pins each browser tab to its own organization: a switch in another tab
// must never redirect this tab's requests. localStorage only seeds the choice of new tabs.
const get = () => window.sessionStorage.getItem(KEY) || ls(KEY) || null;

const set = (organizationId) => {
  window.sessionStorage.setItem(KEY, organizationId);
  ls(KEY, organizationId);
};

const clear = () => {
  window.sessionStorage.removeItem(KEY);
  ls.remove(KEY);
};

export default { get, set, clear };
